import type { SxProps, Theme } from "@mui/material/styles";
import { generalSectionSx } from "../Layout";
import { PRIMARY_COLOR } from "../../theme/consts";

// Scroll container - determines scroll length for animations
export const scrollContainerSx: SxProps<Theme> = {
  height: "180svh",
  position: "relative",
  marginTop: { xs: "-2rem", md: "-10svh", "2xl": "-20svh" },
};

// Sticky container - stays in viewport during scroll
export const stickyContainerSx: SxProps<Theme> = {
  position: "sticky",
  top: 0,
  minHeight: "100svh",
  width: "100%",
  display: "flex",
  overflow: "hidden",
  backgroundColor: "#f8fafc",
  ...generalSectionSx,
};

export const stickyContainerFullBleedSx: SxProps<Theme> = {
  position: "sticky",
  top: 0,
  minHeight: "100svh",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  overflow: "hidden",
  backgroundColor: "#f8fafc",
};

export const stickyInnerContentSx: SxProps<Theme> = {
  ...generalSectionSx,
  width: "100%",
};

export const staticSectionSx: SxProps<Theme> = {
  backgroundColor: "#f8fafc",
};

export const staticContentSx: SxProps<Theme> = {
  ...generalSectionSx,
};

// Content wrapper
export const contentWrapperSx: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

export const headerRowSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "minmax(0, 23rem) minmax(0, 1fr)" },
  gap: { xs: "1.5rem", md: "4rem" },
  alignItems: "start",
};

export const leadTextSx: SxProps<Theme> = {
  color: "text.secondary",
  maxWidth: "38rem",
};

// Rows container
export const rowsContainerSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  width: "100%",
  paddingLeft: { xs: "0", md: "10rem", "2xl": "17rem" },
  maxWidth: "1020px",
  margin: "8rem auto 4rem",
};

export const rowsContainerNoInsetSx: SxProps<Theme> = {
  ...rowsContainerSx,
  paddingLeft: 0,
};

// Base row styles
export const advantageRowSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "220px 1fr" },
  gap: { xs: "1rem", md: "4rem" },
  alignItems: "flex-start",
  py: { xs: "1.25rem", md: "1.5rem" },
  borderBottom: "1px solid #E0E0E0",
};

// Label (e.g., "MARKET REALITY")
export const rowLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: { xs: "1.75rem", md: "2rem" },
  textTransform: "uppercase",
  color: "text.primary",
};

// Highlighted label (primary color for "THE ONTOLOGY EDGE")
export const highlightedLabelSx: SxProps<Theme> = {
  ...rowLabelSx,
  color: PRIMARY_COLOR,
};

// Description text
export const rowDescriptionSx: SxProps<Theme> = {
  color: "text.secondary",
};

// Highlighted description (primary color)
export const highlightedDescriptionSx: SxProps<Theme> = {
  ...rowDescriptionSx,
  color: PRIMARY_COLOR,
};

export const rowTextContentSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
};

export const rowSecondaryDescriptionSx: SxProps<Theme> = {
  color: "text.secondary",
};
